export function capitalizeFirstLetter(input) {
  if (input === null || input === undefined) {
    return input; // Return null or undefined as is
  }

  // Convert the input to a string (works for both numbers and strings)
  const str = input.toString();

  if (str.length === 0) {
    return str;
  }

  return str.charAt(0).toUpperCase() + str.slice(1);
}

// check if number is a Decimal or not
export function isDecimal(num) {
  num = Number(num);
  if (isNaN(num)) {
    return false;
  }
  return num % 1 !== 0;
}
